import {CreateStrategy} from './create-strategy.class';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

export class CreateStrategyAndStart extends CreateStrategy {
  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.CreateStrategyAndStart`;
  }
}
